// Packages

// Components
import { DetailsItems } from "./DetailsItems";

// Logic

// Context

// Services

// Styles

// Assets

export const Details = () => {
	return (
		<div className='unit-page-subpage unit-page-subpage-details'>
			<DetailsItems />
		</div>
	);
};
